/**
 * @author Ryan Gladstone, Umer Hassan
 */

function tasksService($http, $q) {
  const service = {};

  service.getTasksByStoryId = (storyId, story, exisitingTaskId) => {
    const deferred = $q.defer();

    const getTasks = $http({
      method: 'GET',
      url: `api/tasks?storyID=${storyId}`,
      params: {
        includeStory: true
      }
    });

    getTasks.then((response) => {
      const { data } = response;
      let tasks = [];
      if (data && data.results) {
        angular.forEach(data.results, (t) => {
          const currentTask = t;
          if (t.id !== exisitingTaskId) {
            currentTask.story = story;
            tasks.push(currentTask);
          }
        }, tasks);
      }
      if (tasks.length < 1) {
        // If there are no other tasks, return `null` instead of an empty array
        tasks = null;
      }
      deferred.resolve(tasks);
    }, (data) => {
      deferred.reject(data);
    });

    return deferred.promise;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  tasksService
];

module.exports = (ngModule) => {
  ngModule.service('tasksService', arr);
};
